<template lang="pug">
  app-dialog(v-model="$_show" :header="header" confirm-text="Создать" :confirm-disabled="isNotReady" @confirm="createRequest" :width="'500px'")
    .document
      v-form(ref="addDataRequest" v-model="valid")

        app-select(
          v-model="type" 
          :items="requestTypes" 
          item-text="title" 
          item-value="id" 
          label="Тип запроса" 
          :rules="[rules.required]"
        )
        
        .template(v-if="type == requestType.local")
          .local.mb-7
            v-btn.mx-0(@click="$refs.localfile.click()") Выберите файл
              v-icon(right dark) attach_file
            input(type="file" style="display: none" ref="localfile" :accept="acceptFormats" @change="onFilePicked" )
            .wrap.mt-1  {{ form.originalName }}
        
        app-select(
          v-if="isCategoriesLoaded"
          v-model="addresser.org" 
          :items="categories" 
          item-text="title" 
          label="Категория" 
          no-data-text="Категории не найдены" 
          persistent-hint hint="Вы можете выбрать категорию, чтобы отфильтровать список организаций"
          @input="filterByCategory"
        )

        app-select(
          v-if="isOrgsLoaded"
          v-model="form.selectedOrganization" 
          :items="orgList" 
          item-text="name" 
          label="Организация" 
          persistent-hint hint="Выберите организацию"
          @input="updateOrgTemplates"
        )

        .template(v-if="type == requestType.template")
          app-select(
            v-model="form.selectedTemplate" 
            :items="orgTemplates" 
            label="Шаблон" 
            item-text="walias" 
            return-object 
            no-data-text="Шаблонов не найдено" 
            @input="onTemplateSelected"
            :rules="[rules.required]"
          )
        
        app-text-field(v-model="form.name" label="Имя документа" :rules="[rules.required]")
        
        app-select(
          v-model="form.caseMember" 
          :items="members" 
          item-text="displayName" 
          label="Сторона по делу" 
          :rules="[rules.required]"
        )


</template>

<script>

//        .template(v-if="type == requestType.template && form.selectedTemplate!=null && form.selectedTemplate.deliveryType.value>0")
//            v-checkbox( v-model="EDS" label="Подписать ЭЦП" )

import { mapGetters, mapState, mapMutations } from 'vuex';
import { AppDialogToggable } from '@/components'
import { organizationService } from "@/_services"
import { requestType } from './constants.js'
import { $_validate_rules } from '@/common/ValidateRules'

export default {
  mixins: [AppDialogToggable, $_validate_rules],

  props: {
    members: null,
  },
  
  data () {
    const defaultForm = Object.freeze({
      selectedTemplate: null,
      originalName: '',
      name: '',
      selectedOrganization: [],
      caseMember: null
    })

    return {
      valid: false,
      form: Object.assign({}, defaultForm),
      type: requestType.template,
      requestType,
      defaultForm,
      organizations: [],
      orgTemplates: [],
      addresser: {
        org: null,
        category: '',
      },
    }
  },

  watch: {
    $_show (value) {
      if (value) {
        this.orgTemplates=[]
        this.form = Object.assign({}, this.defaultForm)
      }
    }
  },

  computed: {
    ...mapGetters('courtCase', ['caseId','currentSession']),
    ...mapState('organization', [ 'selectedCategory']),
    ...mapGetters('organization', ['orgs','isOrgsLoaded','categories','isCategoriesLoaded']),

    header () {
      return 'Запрос'
    },

    orgList() {
      let list = (this.selectedCategory == null) ? this.orgs : this.orgs.filter(c => c.organizationCategory!=null && c.organizationCategory.value == this.selectedCategory.value)
      return list
    },

    acceptFormats () {
      let types = [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
      ]
      return types.join(', ')
    },

    isNotReady () {
      if(!this.valid) return true
      return false
    },

    requestTypes () {
      return [
        { title: 'На основе шаблона', id: requestType.template},
        { title: 'Локальный компьютер', id: requestType.local} 
      ]
    },

  },

  methods: {
    ...mapMutations('organization', [ 'selectCategory']),

    filterByCategory(cat) {
      this.selectCategory(cat)
    },

    updateOrgTemplates(item) {
      organizationService.orgtemplates(item.id)
      .then(data => this.orgTemplates = data ? data : [])
      
    },

    uploadFile () {
      let formData = new FormData();
      formData.append("file", this.$refs.localfile.files[0])

      organizationService.uploadFiles(formData)
      .then(data => this.sendRequest(data))
      .catch(e => console.log(e))
    },

    createRequest () {
      if (this.$refs.addDataRequest.validate()) {
         if (this.type == requestType.local) {
           this.uploadFile()
         } else {
           this.sendRequest()
         }
      }
    },

    sendRequest (fileName = '') {
      let obj = {
        "caseSessionId": this.currentSession.id, 
        "fileRequestTemplateId": this.form.selectedTemplate? this.form.selectedTemplate.id : null,
        "organizationId": this.form.selectedOrganization.id,
        "caseMemberId": this.form.caseMember.id,
        "name": this.form.name,
        "fileName": fileName
      }
      
      organizationService.request(obj)
        .then(() => this.toCase())
        .catch(e => console.log(e))
    },

    onFilePicked (e) {
		const files = e.target.files
		if (files[0] !== undefined) {
            this.form.originalName = files[0].name
			this.form.name = files[0].name
        }
    },

    onTemplateSelected () {
      this.form.name = this.form.selectedTemplate.name
    }, 

    toCase () {
        this.$store.dispatch('courtCase/LOAD_CASE', this.caseId)
    }, 

  },
  created() {
    this.$store.dispatch('organization/INIT')
  }
}
</script>

<style scoped>
.document {
  padding: 16px 0px;
}
</style>
